module.exports = __webpack_public_path__ + "static/media/logo.a6f23072.png";